import {EuiIcon} from '@elastic/eui'
import { ReactElement } from 'react'
import { TypeEuiPropsIcon } from 'Type'

const ComponentEuiIcon = ({color, className, size, type, onIconLoad, titleId} :TypeEuiPropsIcon) :ReactElement<TypeEuiPropsIcon> =>
    <EuiIcon color={color} className={className} size={size} type={type} onIconLoad={onIconLoad} titleId={titleId}/>

export default ComponentEuiIcon